import { Button, Modal, Space, Menu, Dropdown, Tooltip } from 'antd';
import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../store';
import api from '../../service/api';
import {
  loadRequest,
  sorterSolicitacoesRetorno,
} from '../../store/ducks/solicitacoesRetorno/actions';
import {
  CloseCircleOutlined,
  WarningOutlined,
  EllipsisOutlined,
  PrinterOutlined,
} from '@ant-design/icons';
import { Container, Div } from './styles';
import TitlePage from '../../components/TitlePage';
import Filter from './components/Filter';
import ListSteps from './components/ListSteps';
import ModalAtendimentoSaida from './components/Modal';
import mask, { maskCurrency, maskUnd } from '../../utils/mask';
import { SKW_AUTH, SKW_PREFIX } from '../../utils/constants';
import Swal from 'sweetalert2';
import { ColumnType } from 'antd/lib/table';
import { Sorter, sorterParamsHandle } from '../../utils/sorte';
import TableSort from '../../components/TableSort';
import { saveAs } from 'file-saver';
import { useWindowSize } from '../../hook/useWindowSize';
import CardMobile from './components/CardMobile';
import ModalTransportadora from './components/ModalTransportadora';
import AnchorButton from '../../components/AnchorButton';
import { HandleClickRowActive } from '../../utils/handleclickrowactive';
import GetStatus from '../../components/GetStatus';
import { Group } from './types';
import moment from 'moment';
import TextTable from '../../components/TextTable';
import Refresh from '../../components/Refresh';
import { Pedidos } from './services/estoqueServices';
import { dadosFormatados } from './utils/formataTabela';
import { ExportBtn } from 'components/_REFACTORED/ExportBtn';

const SolicitacoesRetorno: React.FC = () => {
  const solicitacoesRetorno = useSelector(
    (state: ApplicationState) => state.SolicitacoesRetorno.data
  );
  let loading = useSelector((state: ApplicationState) => state.SolicitacoesRetorno.loading);
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const filter = useSelector((state: ApplicationState) => state.SolicitacoesRetorno.filter);
  const pagination = useSelector((state: ApplicationState) => state.SolicitacoesRetorno.pagination);
  const dispatch = useDispatch<Dispatch<Action>>();
  const { width }: any = useWindowSize();

  const handlePdf = (nuNota: number) => {
    api
      .get(
        `/call?serviceName=${SKW_PREFIX}imprimeAutorizacaoEntrega&token=${token}&nuNota=${nuNota}`,
        {
          responseType: 'arraybuffer',
        }
      )
      .then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        saveAs(blob, 'AUTORIZAÇÃO.pdf');
      });
  };

  const getData = async () => {
    const { data } = await Pedidos.getAllData(
      cddAtivo?.codCdd,
      filter,
      inscricaoAtiva,
      pagination.total
    );

    const exportData = dadosFormatados(data.pedidos);
    return exportData;
  };

  const dataExport = dadosFormatados(solicitacoesRetorno);

  const columns: ColumnType<Group>[] = [
    {
      title: 'N° único',
      dataIndex: 'nuNota',
      key: 'nuNota',
      align: 'center',
      width: 100,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
      render: (text: any, record: any) => {
        return (
          <>
            {<ModalAtendimentoSaida text={text} nuNota={record?.nuNota} chave={record?.chaveNfe} />}
          </>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 9,
      },
      render: (text: string, record) => {
        return <GetStatus acronym={text} />;
      },
    },

    {
      title: 'N° do pedido',
      dataIndex: 'numNota',
      key: 'numNota',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 2,
      },
      render: (text: string | number) => {
        return text === 0 ? (
          <TextTable>Pedido não confirmado</TextTable>
        ) : (
          <TextTable>{text}</TextTable>
        );
      },
    },
    {
      title: 'N° da nota',
      dataIndex: 'numNotaEmitida',
      key: 'numNotaEmitida',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 3,
      },
      render: (text: any, record: any) => {
        return !text ? (
          <TextTable>Não informado</TextTable>
        ) : (
          <ModalAtendimentoSaida text={text} nuNota={record?.nuNotaEmitida} />
        );
      },
    },
    {
      title: 'Data solicitação',
      dataIndex: 'dtSolicitacao',
      key: 'dtSolicitacao',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },
      render: (text: any) => {
        return text ? (
          <TextTable>{moment(text).format('LL')}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      title: 'Transportadora',
      dataIndex: 'transportadora',
      key: 'transportadora',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
      render: (text: string) => {
        return text !== '<SEM PARCEIRO>' ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      title: 'Pagador',
      dataIndex: 'pagador',
      key: 'pagador',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 6,
      },
      render(text: string) {
        return text && text !== '<SEM PARCEIRO>' ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Inscrição estadual',
      dataIndex: 'inscricaoEstadualParceiro',
      key: 'inscricaoEstadualParceiro',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 7,
      },
      render(text: string) {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informada</TextTable>;
      },
    },
    {
      title: 'Depositante',
      dataIndex: 'parceiro',
      key: 'parceiro',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 8,
      },
      render(text: string) {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Usuário solicitante',
      dataIndex: 'nomeUsu',
      key: 'nomeUsu',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 8,
      },
      render(text: string) {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: 'Peso bruto',
      dataIndex: 'peso',
      key: 'peso',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 10,
      },
      render: (text: number = 0) => {
        return text ? (
          <TextTable>{maskUnd(text)} KG</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Valor da mercadoria',
      dataIndex: 'valor',
      key: 'valor',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 11,
      },
      render: (text: number = 0) => {
        return text !== null ? (
          <TextTable>{maskCurrency(text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Ação',
      dataIndex: 'acao',
      key: 'acao',
      width: 100,
      fixed: 'right',
      render: (text: any, record: any) => {
        const menuDropDown = (
          <Menu>
            <Menu.Item onClick={() => handlePdf(record.nuNota)}>
              <Button type="ghost" block className="primary" icon={<PrinterOutlined />}>
                Imprimir
              </Button>
            </Menu.Item>

            <Menu.Item>
              <Tooltip
                title={record.status !== 'SL' && 'Essa soliciação não pode mais ser cancelada.'}
              >
                <Button
                  danger
                  type="default"
                  size="middle"
                  block
                  icon={<CloseCircleOutlined />}
                  disabled={record.status !== 'SL'}
                  onClick={() => confirmarCancelarPedido(record.nuNota)}
                >
                  Cancelar Pedido
                </Button>
              </Tooltip>
            </Menu.Item>

            <Menu.Item>
              <ModalTransportadora nuNota={record.nuNota} />
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menuDropDown}>
            <Button type="text" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              <EllipsisOutlined
                style={{ fontSize: '30px', transform: 'rotate(90deg)', color: '#3c6ab4' }}
              />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  const confirmarCancelarPedido = (nuNota: number) => {
    Modal.confirm({
      title: 'Confirmar cancelamento de pedido',
      icon: <WarningOutlined />,
      content: `Deseja cancelar o pedido ${nuNota}?`,
      okText: 'Sim',
      cancelText: 'Não',
      centered: true,

      async onOk() {
        await api
          .post(
            `call?serviceName=${SKW_PREFIX}cancelaPedido&accessKey=${SKW_AUTH}&hasTransaction=true&token=${token}`,
            { nuNota: nuNota }
          )
          .then((_res) => {
            Swal.fire({
              title: `Pedido n° ${nuNota} foi cancelado com sucesso!`,
              html: '',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            });
            //atualizar lista
            dispatch(loadRequest({}, inscricaoAtiva, cddAtivo?.codCdd));
          })
          .catch((err) => {
            Swal.fire({
              title: `Não foi possível cancelar o pedido n° ${nuNota}.`,
              html: err.response?.data.titulo,
              icon: 'error',
              showConfirmButton: false,
              timer: 1500,
            });
          });
      },
    });
  };

  return (
    <>
      <Refresh
        loadRequest={() =>
          dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd, pagination))
        }
      />
      <Filter />

      <Container>
        <TitlePage>
          <span>
            <AnchorButton textRoute={'solicitacaoretorno'} />
            Solicitações de retorno
          </span>

          <div className="box">
            <ExportBtn onGetAllData={getData} screenData={dataExport} filename={'solicitacoes'} />
          </div>
        </TitlePage>

        {width > 768 && (
          <TableSort
            style={{ fontSize: 10, display: 'inline', marginRight: '6.5%' }}
            columns={columns}
            scroll={{ x: 2400 }}
            size={'large'}
            dataSource={solicitacoesRetorno}
            className="table"
            loading={loading}
            rowKey={'nuNota'}
            pagination={pagination}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(
                loadRequest(
                  filter,
                  filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
                  cddAtivo?.codCdd,
                  pagination,
                  sorterParamsHandle(sorter)
                )
              );
              dispatch(sorterSolicitacoesRetorno(sorterParamsHandle(sorter)));
            }}
            onRow={(record: any, rowIndex: any) => {
              return {
                onClick: (event: React.MouseEvent<HTMLElement>) =>
                  HandleClickRowActive(event, record),
              };
            }}
            expandable={{
              expandedRowRender: (record: any) => (
                <Div>
                  <Space className="full-width" direction="vertical" size="small">
                    <ListSteps record={record} />
                  </Space>
                </Div>
              ),
            }}
          />
        )}
        {width <= 768 && (
          <>
            <CardMobile
              props={solicitacoesRetorno}
              pagination={pagination}
              loading={loading}
              inscricaoAtiva={inscricaoAtiva}
              cddAtivo={cddAtivo}
              filter={filter}
              confirmarCancelarPedido={confirmarCancelarPedido}
              handlePdf={handlePdf}
            />
          </>
        )}
      </Container>
    </>
  );
};

export default SolicitacoesRetorno;
